<template>
  <v-main>
    <v-alert class="hidden-xs-only" dismissible color="success" icon="mdi-check-circle"
             v-model="submitcontactsuccessalert" transition="scale-transition">
      Message Sent! Thanks for the feedback, I'll get back to you ASAP
    </v-alert>
    <v-alert class="hidden-xs-only"  dismissible color="error" icon="mdi-alert-outline"
             v-model="submitcontactfailurealert" transition="scale-transition">
      There was an error submitting your message. I'll try and fix it and see what's up.
    </v-alert>
    <v-alert class="hidden-xs-only"  dismissible color="warning" icon="mdi-alert-outline"
             v-model="submitcontactnoreasonalert" transition="scale-transition">
      There was an error submitting your message. Make sure to select a reason for your message.
      If you did, then something broke, and I'll get to fixing it!
    </v-alert>
    <head>
      <title>Contact Us - Foraje</title>
    </head>

    <section>
      <v-container>
        <v-row justify="center" class="my-5">
          <v-col cols="12" >
            <h1 class="layout justify-center">Contact Us</h1>
              <v-row class="align-center justify-center">
                <v-col cols="12" sm="6" md="4" style="text-align: center">
            If you have
            any ideas on how I can make Foraje better, or if you've run into any weird errors or
              bugs, I want to know about them! Please contact me using the form, or through any of
              the other contact methods listed below. Thanks for your help and advice,
              let's make Foraje awesome!
                </v-col>
              </v-row>
          </v-col>
          <v-col cols="12" sm="6" md="4">
            <form @submit.prevent="SubmitContactForm">
              <v-card>
                <v-card-title primary-title class="layout justify-center">
                  <div class="headline">Contact Form</div>
                </v-card-title>
                <v-card-text>
                  <v-select
                    name="contractreason"
                    label="Reason You're Contacting Foraje*"
                    hint="Errors, Ideas, Suggestions, Things that are broken,
                    Hate Mail, whatever! (please don't send hate mail...)"
                    id="contactreason"
                    v-model="contactreason"
                    :items="reasonsitems"
                    item-text="text"
                    item-value="value"
                    required
                  >
                  </v-select>
                  <v-text-field
                    name="contactemail"
                    label="Your Email*"
                    id="contactemail"
                    v-model="contactemail"
                    type="email"
                    hint="So I can get back to you about the problem."
                    required
                  >

                  </v-text-field>
                  <v-text-field
                    name="contactname"
                    label="Your Name*"
                    id="contactname"
                    v-model="contactname"
                    hint="Just so I know who I'm responding to!
                    (and who to thank if you send me a really good suggestion!)"
                    required>

                  </v-text-field>
                  <v-textarea
                    name="contactbody"
                    label="Your Message*"
                    id="contactbody"
                    v-model="contactbody"
                    hint="Whatever you're trying to tell me!"
                    required
                  >

                  </v-textarea>
                </v-card-text>
                <v-card-actions>
                  <v-btn class="layout justify-center" type="submit" color="secondary">
                    Send the message!
                    <span slot="loader" class="custom-loader">
                        <v-progress-circular indeterminate color="primary"></v-progress-circular>
                       </span>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </form>
            <v-alert class="hidden-sm-and-up" dismissible color="success" icon="mdi-check-circle"
                     v-model="submitcontactsuccessalert" transition="scale-transition">
              Message Sent! Thanks for the feedback, I'll get back to you ASAP
            </v-alert>
            <v-alert class="hidden-sm-and-up" dismissible color="error" icon="mdi-alert-outline"
                     v-model="submitcontactfailurealert" transition="scale-transition">
              There was an error submitting your message. I'll try and fix it and see what's up.
            </v-alert>
            <v-alert class="hidden-sm-and-up" dismissible color="mdi-alert-outline" icon="warning"
                     v-model="submitcontactnoreasonalert" transition="scale-transition">
              There was an error submitting your message. Make sure to select a reason for
              your message. If you did, then something broke, and I'll get to fixing it!
            </v-alert>
          </v-col>
          <v-col cols="12" sm="6" md="4" offset-md="1">
            <v-card>
              <v-card-title primary-title class="layout justify-center">
                <div class="headline">Contact Me</div>
              </v-card-title>
              <v-card-text style="text-align: center">
                Got something you need to reach out about, but the form won't do the trick?
                Contact me through any of these methods
              </v-card-text>
              <v-list class="transparent">


                <v-list-item>
                  <v-list-item-action>
                    <v-icon x-large class="secondary--text text--lighten-2">mdi-map-marker</v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <a href="https://maps.google.com/?q=50 Milk Street, Floor 15 Boston, MA 02109">
                    <v-list-item-title>1798 Beacon Street #2</v-list-item-title>
                    <v-list-item-subtitle>Brookline, MA 02445</v-list-item-subtitle>
                    </a>
                  </v-list-item-content>
                </v-list-item>


                <v-list-item>
                  <v-list-item-action>
                    <v-icon x-large class="secondary--text text--lighten-2">mdi-twitter</v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title><a href="https://twitter.com/ForajeOfficial">@ForajeOfficial</a></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item>
                  <v-list-item-action>
                    <v-icon x-large class="secondary--text text--lighten-2">mdi-instagram</v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title><a href="https://www.instagram.com/forajeofficial/">@ForajeOfficial</a></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item>
                  <v-list-item-action>
                    <v-icon x-large class="secondary--text text--lighten-2">mdi-email-outline
                    </v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>
                      <a href=mailto:contact@foraje.com>contact@foraje.com</a></v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <!--TODO make all the above selectable-->
              </v-list>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </section>

  </v-main>

</template>

<script>
import axios from 'axios';

// TODO honeypot field, and/or recaptcha check
export default {

  name: 'ContactUs',
  data: () => ({
    submitcontactsuccessalert: false,
    submitcontactfailurealert: false,
    submitcontactnoreasonalert: false,
    contactreason: '',
    contactname: '',
    contactemail: '',
    contactbody: '',
    reasonsitems: [
      { text: 'Question', value: 'question' },
      { text: 'Suggestion/Idea', value: 'suggestion' },
      { text: 'Bug Report/Something Broke', value: 'bug-report' },
      { text: 'Other', value: 'other' },
    ],

  }),
  methods: {
    SubmitContactForm() {
      return axios.post('forms/contact-form/', {
        email: this.contactemail,
        contact_category: this.contactreason,
        name: this.contactname,
        body: this.contactbody,
      })
        .then(() => {
          if (!this.$store.getters.error) {
            this.submitcontactsuccessalert = true;
          }
        })
        .then(() => {
          this.contactreason = '';
          this.contactemail = '';
          this.contactname = '';
          this.contactbody = '';
        })
        .catch(() => {
          if (this.contactreason === '') {
            this.submitcontactnoreasonalert = true;
          } else {
            this.submitcontactfailurealert = true;
          }
        });
    },

  },
  computed: {


  },
};
</script>

<style scoped>

</style>
